<template>
  <modal
    title="Add to Blacklist"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="text-sm font-semibold mt-4">
      <p v-if="contactIds.length">
        You are about to blacklist multiple contacts!
      </p>
      <p v-else>You are about to blacklist {{ this.contact.name }}!</p>
    </div>
    <div class="py-6">
      <label class="label">Reason for Blacklist:</label>
      <input
        type="text"
        class="input"
        placeholder="Enter"
        v-model="payload.suspendReason"
      />
    </div>

    <div class="actions flex justify-between">
      <div class="cursor-pointer" @click="closeModal">
        <p>Cancel</p>
      </div>
      <div>
        <primary-button
          buttonText="Blacklist"
          :loading="loading"
          @click="blacklistContact"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    contact: {
      required: true,
    },
    contactIds: {
      required: false,
    },
    // isMultipleContacts: {
    //   required: false
    // }
  },
  data() {
    return {
      loading: false,
      payload: {
        contactId: [this.contact.id],
        isSuspended: true,
        suspendReason: "",
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    async blacklistContact() {
      this.loading = true;
      if (this.contactIds.length) {
        this.payload.contactId = this.contactIds;
      } else {
        this.payload.contactId = [this.contact.id];
      }
      // let payload = {
      //   payload: {
      //     ...this.payload,
      //   },
      // };
      try {
        const response = await this.$_blacklistContact(this.payload);
        console.log(response);
        this.generateToast("Contact(s) blacklisted!", "success");
        this.$emit("contact-blacklisted");
        this.closeModal();
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
